import { render, staticRenderFns } from "./EstadisticaProyecto.vue?vue&type=template&id=fafa900a&scoped=true&"
import script from "./EstadisticaProyecto.vue?vue&type=script&lang=js&"
export * from "./EstadisticaProyecto.vue?vue&type=script&lang=js&"
import style0 from "./EstadisticaProyecto.vue?vue&type=style&index=0&id=fafa900a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa900a",
  null
  
)

export default component.exports